import { UserUtilityService } from './../../../../../services/user-utility.service';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { userActions } from 'src/app/models/enums/user-permissions.enum';

@Component({
    selector: 'app-override-flange',
    templateUrl: './override-flange.component.html',
    styleUrls: ['./override-flange.component.scss'],
})
export class OverrideFlangeComponent implements OnInit {
    tooltip_position = 'above';
    isOverrideFlange: boolean;
    @Input() form: UntypedFormGroup;

    constructor(private userUtilityService: UserUtilityService) {
        this.isOverrideFlange = false;
    }

    async ngOnInit(): Promise<void> {
        if (this.form.get('gasket').value && !this.form.get('enableOveride').value) {
            this.form.get('enableOveride').enable();
        }
        // * checking access level
        this.isOverrideFlange = await this.userUtilityService.checkUserPermissionDataAndRoute('view-overriddenflange', userActions.View);
    }
}
